module.exports = __webpack_public_path__ + "img/bgpattern-bottom.0df539d0.png";